export default __webpack_public_path__ + "static/media/CS_11.b1ddd2d1.png";